export default __webpack_public_path__ + "static/media/blog_one.883b7b85.png";